import posthog from "posthog-js";

const key = import.meta.env.VITE_POSTHOG_KEY;
const host = import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com";

let initialized = false;

function ensureInitialized() {
  if (initialized || !key) return;
  posthog.init(key, {
    api_host: host,
    capture_pageview: false, // client-side router — pageviews are captured manually on route change
    autocapture: true,
    opt_out_capturing_by_default: true,
    opt_out_persistence_by_default: true, // no PostHog cookies/localStorage until analytics consent
  });
  initialized = true;
}

export function syncPostHogConsent(analyticsConsent: boolean) {
  ensureInitialized();
  if (!initialized) return;
  if (analyticsConsent) posthog.opt_in_capturing();
  else posthog.opt_out_capturing();
}

export { posthog };
